import classNames from 'classnames';
import { useRouter } from 'next/router';
import WechatIcon from 'public/images/support/wechat.webp';
import { type FC, useState } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';
import { checkLocaleCn } from 'src/utils/locale';
import styles from './index.module.scss';

type Props = {
  isProxy?: boolean;
  title?: string;
  description?: string;
  bottomText?: string;
  position?: 'right' | 'left';
  width?: number;
  height?: number;
};

export const WechatContact: FC<Props> = ({
  isProxy = false,
  title = '请长按扫一扫QR码',
  description = '关注 玩尽日本WAmazing公众号',
  bottomText = '关注公众号后即可咨询',
  position = 'left',
  width = 40,
  height = 40
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { locale } = useRouter();

  if (!checkLocaleCn(locale)) return null;

  return (
    <>
      <div
        className={classNames(styles.wrapper, { [styles.right]: position === 'right' })}
        onClick={() => setIsOpen(true)}
      >
        <NextImage src={WechatIcon} alt="WeChat" width={width} height={height} />
      </div>
      {isOpen && (
        <CommonModal closeModal={() => setIsOpen(false)}>
          <div className={styles.qrModalContainer}>
            <div className={styles.title}>{title}</div>
            <div>{description}</div>
            <div className={styles.qrWrapper}>
              <NextImage
                src={
                  isProxy
                    ? `${CLOUD_FRONT_IMAGE_PATH}/shared/wechat/proxyPurchaseSupportQr.webp`
                    : `${CLOUD_FRONT_IMAGE_PATH}/shared/wechat/wechatSupportQr.webp`
                }
                alt="WeChat Support Qr Code"
                width={180}
                height={180}
              />
            </div>
            <div>{bottomText}</div>
          </div>
        </CommonModal>
      )}
    </>
  );
};
